import { render, staticRenderFns } from "./organSupervise.vue?vue&type=template&id=97630922&scoped=true&"
import script from "./organSupervise.vue?vue&type=script&lang=js&"
export * from "./organSupervise.vue?vue&type=script&lang=js&"
import style0 from "./organSupervise.vue?vue&type=style&index=0&id=97630922&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97630922",
  null
  
)

export default component.exports